import { makeRequest } from 'utils/requestLogger';

export default (payload, submission_id) =>
  makeRequest(
    'put',
    `/api/submissions/${submission_id}/edit-submission`,
    payload
  );



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/submission/editSubmission.js